module.exports = __webpack_public_path__ + "static/media/icon_reward_silver.7171d5a5.svg";